import {
  CalculationStandardSettings,
  SumStandardSettings,
} from 'apps/studio/components/settings/fields/Calculation/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { CalculationPanel } from 'apps/studio/components/settings/fields/Calculation/calculation'
import { AdvancedPanel, CurrencyAdvancedPanel } from 'apps/studio/components/settings/fields/Calculation/advanced'

export const CalculationSettings = [
  FieldSettingsPanel(CalculationStandardSettings),
  DesignSettingsPanel,
  CalculationPanel,
  // ConditionsPanel,
  AdvancedPanel,
]

export const SumSettings = [
  FieldSettingsPanel(SumStandardSettings),
  DesignSettingsPanel,
  // ConditionsPanel,
  AdvancedPanel,
]

export const CalcCurrencySettings = [
  FieldSettingsPanel(CalculationStandardSettings),
  DesignSettingsPanel,
  CalculationPanel,
  // ConditionsPanel,
  CurrencyAdvancedPanel,
]